import workspaceQuery from 'graphql/queries/sales/SalesAttributeConfigWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/sales/SalesAttributeConfigListQuery.graphql';
import instanceQuery from 'graphql/queries/sales/SalesAttributeConfigQuery.graphql';
import defaultQuery from 'graphql/queries/sales/SalesAttributeConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/sales/SalesAttributeConfigMutation.graphql';
import fragment from 'graphql/fragments/sales/SalesAttributeConfigFragment.graphql';

const SalesAttributeConfig = {
  type: 'SalesAttributeConfig',
  title: 'Sales Attributes',
  formTitle: 'Sales Attribute',
  formUrl: '/Sales/AttributeConfig/Details/',
  workspaceUrl: '/Sales/AttributeConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'SALES_ORDER_ATTRIBUTES',
};

export default SalesAttributeConfig;
